import { InstallDocumentTypes, InstallPackageFileCategory } from 'types';

import FormSection from '../Forms/FormSection';
import { DocumentList } from '../MilestonePackagePartials/Documents/DocumentList';

export const InstallLoadProof = ({
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
}: {
  showCheckboxes: boolean;
  checkboxCategories: InstallPackageFileCategory[];
  isPackageEditable?: boolean;
}) => {
  return (
    <FormSection title="Load Calculation" description={'Upload evidence of the load calculation for this site.'}>
      <DocumentList
        documentTypeFilter={[InstallDocumentTypes.proofOfLoad]}
        title="Proof of Load Calculation"
        showTypeLabelOnItems={false}
        baseCategory={InstallDocumentTypes.proofOfLoad}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  );
};
